import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ShieldCheck, ScanSearch, MonitorCog, Scale, FileCheck2 } from 'lucide-react';
import { services, nav } from '../mock';

const icons = {
  'virtual-ciso': ShieldCheck,
  'risk-audits': FileCheck2,
  'penetration-testing': ScanSearch,
  'patch-management-rmm': MonitorCog,
  'regulatory-compliance': Scale,
};

const ServicesIndex = () => (
  <div className="fade-in">
    <section className="hero-gradient border-b border-slate-200">
      <div className="max-w-6xl mx-auto px-6 py-20">
        <div className="text-[12px] uppercase tracking-[0.18em] text-[#1F3864] mb-4">Services</div>
        <h1 className="font-serif-display text-4xl md:text-5xl leading-tight text-[#1F3864] max-w-3xl">Enterprise-caliber cybersecurity services, delivered to small regulated practices.</h1>
        <p className="mt-5 text-[17px] text-slate-700 max-w-2xl">Five practice areas. One accountable principal. Every engagement scoped, executed, and signed by Andrew Garlick.</p>
      </div>
    </section>
    <section className="py-16">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-6">
        {nav.services.map(s => {
          const Icon = icons[s.slug] || ShieldCheck;
          const svc = services[s.slug];
          return (
            <Link key={s.slug} to={`/services/${s.slug}`} className="card-hover group block bg-white border border-slate-200 rounded-sm p-8">
              <div className="w-12 h-12 bg-[#1F3864]/5 text-[#1F3864] rounded-sm flex items-center justify-center mb-5 group-hover:bg-[#1F3864] group-hover:text-white transition-colors">
                <Icon size={22} strokeWidth={1.6} />
              </div>
              <div className="font-serif-display text-[22px] text-[#1F3864] mb-3">{s.title}</div>
              <p className="text-[15px] leading-relaxed text-slate-600">{svc?.hero}</p>
              <div className="mt-6 inline-flex items-center gap-1.5 text-[13.5px] font-medium text-[#2E75B6] group-hover:gap-2.5 transition-all">Learn more <ArrowRight size={14} /></div>
            </Link>
          );
        })}
      </div>
    </section>
  </div>
);

export default ServicesIndex;
